// Schließt schwebende Menüs per Escape auch dann, wenn der Fokus nicht im Menü liegt
// (reiner Maus-Hover, WCAG 1.4.13 "Dismissible"). Reine Funktion: ohne Dokument (SSR) passiert nichts.
export function attachEscapeDismiss(doc, onEscape) {
  if (!doc || typeof doc.addEventListener !== 'function') return () => {};
  const handler = (event) => {
    if (event && (event.key === 'Escape' || event.key === 'Esc')) onEscape(event);
  };
  doc.addEventListener('keydown', handler);
  return () => {
    if (typeof doc.removeEventListener === 'function') doc.removeEventListener('keydown', handler);
  };
}
